import { Component, defaultValue, Schema, type } from "minecs";
import { CollisionCategoryEnum } from "yage/constants/enums";

@Component()
export class RigidCircle extends Schema {
  @type("number")
  @defaultValue(0)
  radius: number;

  @type("boolean")
  @defaultValue(false)
  isStatic: boolean;

  @type("boolean")
  @defaultValue(false)
  isSensor: boolean;

  @type("number")
  @defaultValue(1)
  mass: number;

  @type("boolean")
  @defaultValue(false)
  disabled: boolean;

  @type("boolean")
  @defaultValue(false)
  directionLock: boolean;

  @type("boolean")
  @defaultValue(false)
  velocityLock: boolean;

  @type(CollisionCategoryEnum)
  @defaultValue(CollisionCategoryEnum.DEFAULT)
  collisionCategory: CollisionCategoryEnum;

  @type("boolean")
  @defaultValue(false)
  collisionEvents: boolean;

  @type(["number"])
  collisionMask: CollisionCategoryEnum[];

  @type("boolean")
  @defaultValue(false)
  isometric: boolean;

  @type("number")
  @defaultValue(0)
  restitution: number;

  // Collider friction; 0.5 is Rapier's own default. Serialized with the
  // world so component-only rebuilds re-apply the same policy.
  @type("number")
  @defaultValue(0.5)
  friction: number;
}

@Component()
export class RigidCircleResolver extends Schema {}
